import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'searchContact'
})
export class SearchContactPipe implements PipeTransform {

  transform(contacts: any[], searchTerm?: any, alreadyExist?: any[]): any {
    if (searchTerm === null) {
      return contacts;
    }
    searchTerm = searchTerm.indexOf('(C)') > -1 ? searchTerm.substring(searchTerm.indexOf('(C)')+3) : searchTerm;
    const result = contacts.filter((con: any) =>
              con.name.toLowerCase().split(',').some((element) =>
                element.includes(searchTerm.toLowerCase()) && alreadyExist.indexOf(element) === -1)
        ) ;

        return result.length === 0 ? [{name: 'No contacts found', firstName: 'No contacts found'}] : result;
  }

}
